module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/Calc-15571a5ab4e2a04d47d9a024b5404403.png";